import { useCallback, useState } from 'react';

export function useSectionStates<T>(sectionKeys: T[]) {
  const [sectionStates, setSectionStates] = useState(
    sectionKeys.map((key) => ({
      key,
      isOnEdition: false,
    })),
  );

  const toogleSectionEditMode = useCallback((sectionKey: T) => {
    setSectionStates((prevState) =>
      prevState.map((section) =>
        section.key === sectionKey ? { ...section, isOnEdition: !section.isOnEdition } : section,
      ),
    );
  }, []);

  const isSectionEditable = useCallback(
    (sectionKey: T) => !!sectionStates.find((section) => section.key !== sectionKey && !!section.isOnEdition),
    [sectionStates],
  );

  const isSectionOnEdition = useCallback(
    (sectionKey: T) => sectionStates.find(({ key }) => key === sectionKey).isOnEdition,
    [sectionStates],
  );

  return {
    sectionStates,
    toogleSectionEditMode,
    isSectionEditable,
    isSectionOnEdition,
  };
}
